module.exports = __webpack_public_path__ + "static/media/system.089347f0.png";